import { render, staticRenderFns } from "./PremiumMarketAddModal.vue?vue&type=template&id=30b4abe0&scoped=true&"
import script from "./PremiumMarketAddModal.vue?vue&type=script&lang=js&"
export * from "./PremiumMarketAddModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b4abe0",
  null
  
)

export default component.exports